import { render, staticRenderFns } from "./SidebarCrmFilesBlock.vue?vue&type=template&id=3bddbb50"
import script from "./SidebarCrmFilesBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarCrmFilesBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bddbb50')) {
      api.createRecord('3bddbb50', component.options)
    } else {
      api.reload('3bddbb50', component.options)
    }
    module.hot.accept("./SidebarCrmFilesBlock.vue?vue&type=template&id=3bddbb50", function () {
      api.rerender('3bddbb50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarCrmFilesBlock.vue"
export default component.exports